import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../auth/Auth.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-branding">
        <div className="auth-branding-inner">
          <div className="auth-logo"><img src="/wf-logo.png" alt="Wow Factor Baseball" style={{width:'192px',height:'192px',objectFit:'contain'}} /></div>
          <h1 className="auth-brand-name">WOW FACTOR</h1>
          <p className="auth-brand-sub">Baseball Training & Development</p>
          <div className="auth-brand-divider" />
          <p className="auth-brand-quote">Built different.<br />Train with purpose.</p>
        </div>
      </div>
      <div className="auth-form-panel">
        <div className="auth-form-container">
          {sent ? (
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:'3rem', marginBottom:'16px' }}>📧</div>
              <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.8rem', letterSpacing:'0.05em', marginBottom:'12px' }}>CHECK YOUR EMAIL</h2>
              <p style={{ color:'var(--text-secondary)', lineHeight:'1.6', marginBottom:'24px' }}>If an account exists for <strong style={{color:'var(--text-primary)'}}>{email}</strong>, a password reset link has been sent. Check your inbox and spam folder.</p>
              <p style={{ fontSize:'0.85rem', color:'var(--text-muted)', marginBottom:'24px' }}>The link expires in 1 hour.</p>
              <Link to="/login" className="btn btn-primary" style={{ display:'inline-flex' }}>Back to Login</Link>
            </div>
          ) : (
            <>
              <div className="auth-form-header">
                <h2>Forgot Password</h2>
                <p>Enter your email and we will send you a reset link</p>
              </div>
              <form onSubmit={handleSubmit} className="auth-form">
                {error && <div className="auth-error-banner"><span>⚠</span> {error}</div>}
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input type="email" className="form-input" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
                </div>
                <button type="submit" className="btn btn-primary btn-lg auth-submit-btn" disabled={loading}>
                  {loading ? <span className="auth-spinner" /> : 'Send Reset Link'}
                </button>
              </form>
              <div className="auth-form-footer">
                <p>Remember your password? <Link to="/login" className="auth-link">Sign in</Link></p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
